import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=c8a505dc&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=c8a505dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a505dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8a505dc')) {
      api.createRecord('c8a505dc', component.options)
    } else {
      api.reload('c8a505dc', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=c8a505dc&scoped=true&", function () {
      api.rerender('c8a505dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UFWKzIExgYnh/JS/comp/DateRangeExt.vue"
export default component.exports